import Modalbox from '../utils/_modal-box'

const $ = jQuery

export default function VideoModal () {
  new Modalbox('.open-video-modal')
}
